/* src/app/pages/search/search.component.css */
.search-container {
  background-color: #F4F7F8;
  min-height: 192px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 54px;
}
.search-title {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;
  font-family: "Gotham Bold";
  font-size: 20px;
  line-height: 25px;
  color: #323E48;
}
.search-row {
  display: flex;
  justify-content: center;
  gap: 34px;
  margin-bottom: 37px;
  min-height: 50px;
  height: auto;
  flex-wrap: wrap;
}
.select-group {
  display: flex;
  gap: 30px;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
.select-wrapper {
  width: 263px;
}
.form-select {
  width: 100%;
  height: 50px;
  font-size: 15px;
  padding: 0 20px;
  font-family: "Gotham Medium";
  color: #323E48;
  border: none;
  line-height: 20px;
  border-radius: 6px 6px 0 0;
  border-bottom: 1px solid #5B6670;
  background-color: white;
  background-position: right 20px center;
}
.form-select:focus {
  outline: none !important;
  box-shadow: none !important;
}
select option {
  font-family: "Gotham Book";
  font-size: 15px;
  height: 50px;
  padding: 14px 20px;
}
.btn-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
}
.btn {
  height: 45px;
  width: 146px;
  padding: 10px 30px;
  background-color: #EB0029;
  color: #FFFFFF;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
}
.btn-text {
  text-align: center;
  font-family: "Gotham Medium";
  font-size: 15px;
  line-height: normal;
}
.btn-icon {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 0px 3.915px 0px 3px;
  justify-content: center;
  align-items: center;
}
.btn:hover {
  background-color: #E30028;
}
.btn:active {
  background-color: #E30028 !important;
  color: #FFFFFF !important;
  box-shadow: inset 0 2px 4px rgba(104, 1, 1, 0.3) !important;
}
.btn:disabled {
  background-color: #CFD2D3;
  color: #A2A9AD;
  cursor: not-allowed;
  opacity: 0.7;
}
.custom-select-wrapper {
  width: 263px;
  position: relative;
  font-family: "Gotham Medium";
}
.custom-select-display {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #5B6670;
  border-radius: 6px 6px 0 0;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  cursor: pointer;
  position: relative;
}
.custom-select-text {
  height: 43px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.custom-select-label {
  font-size: 15px;
  line-height: 18px;
  color: #323E48;
  font-family: "Gotham Medium";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s ease;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-select-label.float {
  font-size: 13px;
  font-family: "Gotham Book";
  color: #5B6670;
  top: 0;
  transform: translateY(0);
}
.selected-value {
  font-size: 15px;
  line-height: 20px;
  color: #323E48;
  font-family: "Gotham Medium";
  margin-top: 26.5px;
}
.custom-select-options {
  position: absolute;
  top: 52px;
  left: 0;
  width: 100%;
  border-radius: 5px 5px 6px 6px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 3;
  margin-top: 6px;
  padding: 0;
  overflow-y: auto;
  max-height: calc(50px * 10);
}
.custom-select-options li {
  padding: 15px 20px;
  font-size: 15px;
  color: #5B6670;
  cursor: pointer;
  font-family: "Gotham Book";
  height: 50px;
  display: flex;
  align-items: center;
}
.custom-select-options li:hover {
  background-color: #F4F7F8;
  color: #323E48;
}
.arrow {
  transition: transform 0.3s ease;
  transform-origin: center;
  width: 15px;
  height: 7.16px;
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/search.component.css.map */
